/**
 * Field molecule — label, control, and optional description.
 * Compose: FieldLabel (with htmlFor), Input/InputGroup, FieldDescription.
 * @see https://ui.shadcn.com/docs/components/radix/field
 */

import React from "react";
import { Typography } from "../../atoms/Typography";
import { cn } from "@/utils/cn";
import type { FieldProps, FieldLabelProps, FieldDescriptionProps } from "./Field.types";

export const Field: React.FC<FieldProps> = ({ children, className }) => (
  <div className={cn("space-y-2", className)}>{children}</div>
);

export const FieldLabel: React.FC<FieldLabelProps> = ({
  children,
  htmlFor,
  className,
}) => (
  <Typography
    as={htmlFor ? "label" : "span"}
    variant="body-sm"
    weight="semibold"
    color="primary"
    htmlFor={htmlFor}
    className={cn("block", className)}
  >
    {children}
  </Typography>
);

export const FieldDescription: React.FC<FieldDescriptionProps> = ({
  children,
  className,
}) => (
  <Typography
    as="p"
    variant="body-xs"
    color="secondary"
    className={cn(className)}
  >
    {children}
  </Typography>
);
